
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'

import { storage, isEmptyString} from "../js/common";
import api from "../js/api";
import http from "../js/http";

export default {
components: {
Grid,
GridItem
},
data() {
return {
}
},
created() {
},
methods: {
onNavigation(path){
this.$router.push({
path: path
});
}
}
}



// WEBPACK FOOTER //
// ./src/components/index_my.vue